import { ModuleManager, SectionList } from "@module-system";
import component from "./Components/RemoteFlashTrigger.vue";
import configurationProvider from "@/Core/configurationProvider";

/**
 * @type {import('@module-system').IModule}
 */
const module = {
  name: "RemoteFlashTrigger",
  version: "1.0.0",
  register() {
    ModuleManager.addViewModule({
      key: "RemoteFlashTrigger",
      section: SectionList.CallButtonsList,
      ViewComponent: component,
      Condition: (rtcId) => {
        return configurationProvider.getBool("REMOTE_FLASH_TRIGGER_ENABLED", true);
      }
    });
  },
};
export default module;